interface UserInfo {
	id: string;
	email: string;
	school?: string;
	gradYear?: number;
	examDate?: string;
	name?: string;
	isOnboarded?: boolean;
}
type AchievementType = {
	title: string;
	description: string;
	points: number;
	level: number;
	events: number;
	totalEvents: number;
	usersEarned: number;
	icon: {
		url: string;
		backgroundColor: string;
	};
};
export type { UserInfo, AchievementType };
